import { render, staticRenderFns } from "./PrivacyinfoDetail_20240201.vue?vue&type=template&id=5cdd33ef&scoped=true&"
import script from "./PrivacyinfoDetail_20240201.vue?vue&type=script&lang=js&"
export * from "./PrivacyinfoDetail_20240201.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyinfoDetail_20240201.vue?vue&type=style&index=0&id=5cdd33ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd33ef",
  null
  
)

/* custom blocks */
import block0 from "./PrivacyinfoDetail_20240201.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports